<div
  class="w-full px-8 pt-8 pb-16 flex-col justify-start items-start gap-2.5 inline-flex"
>
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div class="bibliotheque self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
    <div class="mb-3">
      <div class="text-3xl text-gray-800 dark:text-white mb-2">
        Ma bibliothèque
      </div>
      <p class="text-gray-600">Vous trouverez ici la lsite de vos outils.</p>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-4 mt-6">
      <div
        *ngFor="let item of bibliotheques"
        class="shadow border-1 border-gray-300 rounded-lg dark:border-gray-600 m-3 placeholder-zinc-600 p-6 text-white"
        [style.backgroundColor]="item.color"
      >
        <div class="icons flex justify-center mb-6">
          <img [src]="'assets/icons/' + item.img_src" />
        </div>
        <div class="text-1xl font-bold text-center">{{ item.title }}</div>
        <div class="font-normal text-center">{{ item.subtitle }}</div>
      </div>
    </div>
  </div>
</div>
